// extracted by mini-css-extract-plugin
export default {"scrollbar":"AdrWs","scrollbarSSR":"qAhzh","layoutContainer":"oP2lO","layoutContainerSSR":"jfSkD","leftMenu":"vMvWh","leftMenuNew":"kmgTL"};